import { jsx as _jsx } from "react/jsx-runtime";
import { Badge, getTestId } from '@airtel/air-design-system';
import { useEffect, useState } from 'react';
import { getSingleItemWidgetStyles } from './SingleLineItemStyles';
export var SingleLineItem = props => {
  var index = props.index,
    onItemPress = props.onItemPress,
    item = props.item,
    testID = props.testID,
    itemCount = props.itemCount,
    _props$numberOfColumn = props.numberOfColumns,
    numberOfColumns = _props$numberOfColumn === void 0 ? 1 : _props$numberOfColumn;
  var singleItemWidgetStyles = getSingleItemWidgetStyles(index, numberOfColumns, itemCount);
  var _useState = useState(item),
    quickSelectionItem = _useState[0],
    setQuickSelectionItem = _useState[1];
  useEffect(() => {
    if (item) {
      setQuickSelectionItem(item);
    }
  }, [item]);
  return _jsx(Badge, Object.assign({
    size: "lg",
    style: [singleItemWidgetStyles, quickSelectionItem === null || quickSelectionItem === void 0 ? void 0 : quickSelectionItem.badgeStyle]
  }, quickSelectionItem, {
    onPress: onItemPress
  }, getTestId(testID + '_singleLineItem', index === null || index === void 0 ? void 0 : index.toString())), "single_line_item_" + index);
};